import { setTiposPublicacion } from '../actions/tiposPublicacionActions';
import {
    SET_TIPOS_GRUPO_PLANES,
    SET_TIPOS_PUBLICACION,
    FETCH_TIPOS_PUBLICACION,
    FETCH_TIPOS_PUBLICACION_BYID,
    LOADING_TIPOS_PUBLICACION,
    SET_FILTRO_TIPOS_PUBLICACION,
    RESET_FILTRO_TIPOS_PUBLICACION,
    RESET_TIPOS_PUBLICACION,
    RESET_VALUE_CHECKED,
    RESET_SET_TIPO_PUBLICACIONES,
    UPDATE_LIST_TIPOS_PUBLICACIONES,
    IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB
} from '../actions/types';
import { filtroEstados } from '../helper/ordenHelper';

const initialState = {
    loadingTiposPublicacion: false,
    tiposPublicacion: {},
    tiposPublicaciones: { elementos: [], total: 0, page: 0, totalPages: 0 },
    setTiposPublicacion: [],
    tiposGruposPlanes: [],
    filtro: [],
    estadoGrupoPlanes: [],
    loadedSellerTabTipo: false,
}

export default function (state = initialState, action) {

    switch (action.type) {


        case RESET_SET_TIPO_PUBLICACIONES:
            return {
                ...state,
                setTiposPublicacion: [],
                loadedSellerTabTipo: false,
            }

        case LOADING_TIPOS_PUBLICACION:
            return {
                ...state,
                loadingTiposPublicacion: action.payload
            };

        case RESET_VALUE_CHECKED:
            return {
                ...state,
                tiposGruposPlanes: []
            };

        case SET_TIPOS_PUBLICACION:
            return {
                ...state,
                setTiposPublicacion: action.payload
            };

        case IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB:
            return {
                ...state,
                loadedSellerTabTipo: action.payload
            };

        case FETCH_TIPOS_PUBLICACION:
            const tpData = action.payload?.data ?? action.payload ?? {};
            const tpElementos =
                Array.isArray(tpData?.elementos) ? tpData.elementos :
                    Array.isArray(tpData?.Elementos) ? tpData.Elementos :
                        Array.isArray(tpData?.content) ? tpData.content :
                            Array.isArray(tpData?.Content) ? tpData.Content : [];
            return {
                ...state,
                tiposPublicaciones: {
                    ...tpData,
                    elementos: tpElementos,
                    total: tpData?.total ?? tpData?.Total ?? tpData?.cantidadTotal ?? tpData?.CantidadTotal ?? tpElementos.length,
                    page: tpData?.page ?? tpData?.Page ?? tpData?.numeroPagina ?? tpData?.NumeroPagina ?? 1
                }
            };

        case FETCH_TIPOS_PUBLICACION_BYID: {
            const elementosById = Array.isArray(action.payload?.data?.elementos)
                ? action.payload.data.elementos
                : [];
            const fetchedItem = elementosById.length > 0 ? elementosById[0] : {};

            return {
                ...state,
                tiposPublicacion: fetchedItem,
                // Lista completa: asignarTipoPublicacion y la UI esperan un array, no un solo objeto
                setTiposPublicacion: elementosById
            };
        }

        case SET_TIPOS_GRUPO_PLANES:
            return {
                ...state,
                tiposGruposPlanes: action.payload,
                estadoGrupoPlanes: action.payload
            };

        case RESET_FILTRO_TIPOS_PUBLICACION:
            return {
                ...state,
                tiposPublicaciones: { elementos: [], total: 0, page: 1, totalPages: 0 },
                setTiposPublicacion: []

            };

        case SET_FILTRO_TIPOS_PUBLICACION:
            return {
                ...state,
                filtro: action.payload
            };

        case RESET_TIPOS_PUBLICACION:
            return {
                ...state,
                tiposPublicaciones: { elementos: [], total: 0, page: 1, totalPages: 0 },
            };
        case UPDATE_LIST_TIPOS_PUBLICACIONES:
            return {
                ...state,
                tiposPublicaciones: action.payload,
            };
        default: return state
    }
}